import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import authReducer from 'modules/auth/store';
import { saveState } from 'modules/auth/store/persist';
import masterBoardReducer from 'modules/board-master/store';
import clientTournament from 'modules/client/tournaments/store/client-tournament/client-tournament-store';
import gamesReducer from 'modules/games/store';
import locationsReducer from 'modules/locations/store';
import mainPageReducer from 'modules/main/store/main-page/main-page-store';
import notificationsReducer from 'modules/notifications/store/notifications';
import organizerReducer from 'modules/organizer/store/orginizer';
import socialNetsReducer from 'modules/organizer/store/social-nets/social-nets-store';
import organizersReducer from 'modules/organizers/store';
import rolesManagerReducer from 'modules/roles-manager/store/roles-manager/roles-manager-store';

import TournamentUsersReducer from 'modules/players/store';
import scheduleReducer from 'modules/schedule/store';
import overlayReducer from 'modules/stream/store';
import teamsReducer from 'modules/teams/store';
import entryRequestsReducer from 'modules/teams/store/entry-requests';
import playersReducer from 'modules/teams/store/players';
import templatesEditorReducer from 'modules/template-editor/store';
import tourneysReducer from 'modules/tournaments/store';
import tournamentsReducer from 'modules/tournaments/store/tournaments';
import { createReduxHistoryContext } from 'redux-first-history';
import { baseApi } from 'shared/api/base-api';
import { restApi } from 'shared/api/rest-api';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

export const rootReducer = combineReducers({
  router: routerReducer,
  auth: authReducer,
  organizer: organizerReducer,
  tournaments: tournamentsReducer,
  tourneys: tourneysReducer,
  games: gamesReducer,
  teams: teamsReducer,
  players: playersReducer,
  overlay: overlayReducer,
  templateEditor: templatesEditorReducer,
  organizers: organizersReducer,
  schedule: scheduleReducer,
  tournamentUsersSlice: TournamentUsersReducer,
  masterBoard: masterBoardReducer,
  locations: locationsReducer,
  entryRequests: entryRequestsReducer,
  notifications: notificationsReducer,
  socialNets: socialNetsReducer,
  clientTournament: clientTournament,
  mainPage: mainPageReducer,
  rolesManager: rolesManagerReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [restApi.reducerPath]: restApi.reducer,
});

const defaultMiddlewareConfig = {
  serializableCheck: {
    ignoredPaths: [
      'templateEditor.templates.templates',
      'templateEditor.editor.fabricManager',
      'templateEditor.templates.catalog',
      'schedule.selectedDate',
      'schedule.weeks',
    ],
  },
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(defaultMiddlewareConfig).concat(routerMiddleware, baseApi.middleware, restApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

store.subscribe(() => {
  saveState(store.getState());
});

export const history = createReduxHistory(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
